/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './sidenav-links.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../src/app/sidenav/links/sidenav-links.component';
import * as i5 from '@angular/forms';
const styles_SidenavLinksComponent:any[] = [i0.styles];
export const RenderType_SidenavLinksComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SidenavLinksComponent,data:{}});
function View_SidenavLinksComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',[['class',
      'links__category']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit;
    _ck(_v,1,0,currVal_0);
  });
}
function View_SidenavLinksComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'span',[['class',
      'links__count']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'span',([] as any[]),(null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,3).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,[[1,4]],0,i2.RouterLink,[i2.Router,
          i2.ActivatedRoute,[8,(null as any)],i1.Renderer,i1.ElementRef],{routerLink:[0,
          'routerLink']},(null as any))],(_ck,_v) => {
    const currVal_1:any = (<any>(<any>_v.parent).parent).context.$implicit.prefix;
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = (<any>(<any>_v.parent).parent).context.$implicit.children.length;
    _ck(_v,1,0,currVal_0);
  });
}
function View_SidenavLinksComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'i',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'span',[['class','links__name']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
          i1.ɵted((null as any),[' '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_SidenavLinksComponent_4)),i1.ɵdid(16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    const currVal_2:any = (<any>_v.parent).context.$implicit.children;
    _ck(_v,6,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = ('fa fa-fw fa-' + (<any>_v.parent).context.$implicit.icon);
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.name;
    _ck(_v,3,0,currVal_1);
  });
}
function View_SidenavLinksComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'li',[['class',
      'links__child-link-item'],['routerLinkActive','links__child-link-item--active']],
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onClick()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,[[3,4]],0,i2.RouterLink,[i2.Router,
      i2.ActivatedRoute,[8,(null as any)],i1.Renderer,i1.ElementRef],{routerLink:[0,
      'routerLink']},(null as any)),i1.ɵdid(1720320,(null as any),2,i2.RouterLinkActive,
      [i2.Router,i1.ElementRef,i1.Renderer,i1.ChangeDetectorRef],{routerLinkActive:[0,
          'routerLinkActive']},(null as any)),i1.ɵqud(603979776,3,{links:1}),i1.ɵqud(603979776,
      4,{linksWithHrefs:1}),(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'i',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'span',[['class','links__name']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['','']))],(_ck,
      _v) => {
    const currVal_0:any = _v.context.$implicit.href;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = 'links__child-link-item--active';
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = ('fa fa-fw fa-' + _v.context.$implicit.icon);
    _ck(_v,5,0,currVal_2);
    const currVal_3:any = _v.context.$implicit.name;
    _ck(_v,8,0,currVal_3);
  });
}
function View_SidenavLinksComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'ul',[['class',
      'links__child-list']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_SidenavLinksComponent_6)),i1.ɵdid(802816,(null as any),0,i3.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any))],(_ck,
      _v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.children;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
function View_SidenavLinksComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),11,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,2).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            if (('click' === en)) {
              const pd_1:any = ((<any>_co.onToggleClose(_v.context.$implicit.name)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,[[1,4]],0,i2.RouterLink,[i2.Router,
          i2.ActivatedRoute,[8,(null as any)],i1.Renderer,i1.ElementRef],{routerLink:[0,
          'routerLink']},(null as any)),i1.ɵdid(1720320,(null as any),2,i2.RouterLinkActive,
          [i2.Router,i1.ElementRef,i1.Renderer,i1.ChangeDetectorRef],{routerLinkActive:[0,
              'routerLinkActive']},(null as any)),i1.ɵqud(603979776,1,{links:1}),i1.ɵqud(603979776,
          2,{linksWithHrefs:1}),i1.ɵdid(278528,(null as any),0,i3.NgClass,[i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SidenavLinksComponent_2)),
      i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf'],ngIfElse:[1,'ngIfElse']},(null as any)),(_l()(),i1.ɵand(0,[['linkOrGroup',
          2]],(null as any),0,(null as any),View_SidenavLinksComponent_3)),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SidenavLinksComponent_5)),
      i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵand(0,(null as any),(null as any),0))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (_v.context.$implicit.href || (null as any));
        _ck(_v,2,0,currVal_0);
        const currVal_1:any = (_v.context.$implicit.href? 'links__link-item--active': '');
        _ck(_v,3,0,currVal_1);
        const currVal_2:any = _co.itemClass(_v.context.$implicit);
        _ck(_v,6,0,currVal_2);
        const currVal_3:boolean = !_v.context.$implicit.name;
        const currVal_4:any = i1.ɵnov(_v,9);
        _ck(_v,8,0,currVal_3,currVal_4);
        const currVal_5:any = _v.context.$implicit.children;
        _ck(_v,11,0,currVal_5);
      },(null as any));
}
export function View_SidenavLinksComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'nav',[['class',
      'links']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'div',[['class','links__input-container']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),5,'input',[['class','links__input'],
          ['placeholder','Search...'],['type','text']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i4.SidenavLinksComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,3)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,3).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,3)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,3)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_4:any = ((<any>(_co.filter = $event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i5.DefaultValueAccessor,
          [i1.Renderer,i1.ElementRef,[2,i5.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i5.NgControl,
          (null as any),[i5.NgModel]),i1.ɵdid(16384,(null as any),0,i5.NgControlStatus,
          [i5.NgControl],(null as any),(null as any)),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),2,'ul',[['class','links__list']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_SidenavLinksComponent_1)),i1.ɵdid(802816,
          (null as any),0,i3.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    var _co:i4.SidenavLinksComponent = _v.component;
    const currVal_7:any = _co.filter;
    _ck(_v,5,0,currVal_7);
    const currVal_8:any = _co.displayedLinks;
    _ck(_v,10,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,7).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,7).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,7).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,7).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,7).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,7).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,7).ngClassPending;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_SidenavLinksComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-sidenav-links',
      ([] as any[]),(null as any),(null as any),(null as any),View_SidenavLinksComponent_0,
      RenderType_SidenavLinksComponent)),i1.ɵdid(49152,(null as any),0,i4.SidenavLinksComponent,
      [i2.Router],(null as any),(null as any))],(null as any),(null as any));
}
export const SidenavLinksComponentNgFactory:i1.ComponentFactory<i4.SidenavLinksComponent> = i1.ɵccf('admin-sidenav-links',
    i4.SidenavLinksComponent,View_SidenavLinksComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/sidenav/links/sidenav-links.component.ngfactory.ts